import React from 'react'
import { InstallationStatus } from '@/src/views/parts/nft/InstallationStatus'
import { HistoricalPerformance } from '@/src/views/parts/gc/HistoricalPerformance'
import { VStack } from '@/src/views/parts/bases/VStack'
import { HStack } from '@/src/views/parts/bases/HStack'
import { Center } from '@/src/views/parts/bases/Center'
import { Text } from '@/src/views/parts/bases/Text'
import { EnergyArcadeMachine } from '@/src/views/parts/nft/EnergyArcadeMachine'
import { UserIcon } from '@/src/views/parts/icons/UserIcon'

export type Props = {
  userName: string
  headerImageUrl: string
  maxEnergy: number
  energy: number
  extractedEnergy: number
  feverSparkRemain: number | null
  InstallationStatusProps: React.ComponentProps<typeof InstallationStatus>
  HistoricalPerformanceProps: React.ComponentProps<typeof HistoricalPerformance>
}

export const Layout = (props: Props) => {
  return (
    <VStack className="w-full pt-8">
      <HStack className="h-[280px] w-full items-center bg-black">
        <HStack className="flex-1 items-center">
          <Center className="ml-9">
            <UserIcon />
          </Center>
          <Text className="ml-9 text-3xl font-bold text-neon-blue">{props.userName}</Text>
        </HStack>
        <HStack className="h-full flex-1">
          <Center className="relative aspect-[1] h-full">
            {props.headerImageUrl.length > 0 ? (
              <EnergyArcadeMachine
                imageUrl={props.headerImageUrl}
                maxEnergy={props.maxEnergy}
                energy={props.energy}
                extractedEnergy={props.extractedEnergy}
                feverSparkRemain={props.feverSparkRemain}
                cardSize={'L'}
              />
            ) : null}
          </Center>
        </HStack>
      </HStack>
      <HStack className="w-full p-2">
        <VStack className="m-3 flex-[2]">
          <InstallationStatus {...props.InstallationStatusProps} />
        </VStack>
        <VStack className="m-3 flex-[3]">
          <HistoricalPerformance {...props.HistoricalPerformanceProps} />
        </VStack>
      </HStack>
    </VStack>
  )
}
